module.exports = __webpack_public_path__ + "img/digger.5ef9e626.png";